import {useEffect, useState} from 'react';

import {RESPONSE_STATUSES} from '@/src/app/constants/api';

import requestGetSpecialties from '../utils/requestGetSpecialties';

export interface SpecialtyProps {
  id: number;
  name_de: string;
  name_en: string;
}
const useSpecialties = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [specialties, setSpecialties] = useState<SpecialtyProps[]>([]);

  const fetchSpecialties = async () => {
    setIsLoading(true);
    const {responseBody, status} = await requestGetSpecialties();

    if (status === RESPONSE_STATUSES.SUCCESS) {
      setSpecialties(responseBody.data);
    }

    setIsLoading(true);
  };

  useEffect(() => {
    fetchSpecialties();
  }, []);

  return {
    specialties,
    isLoading,
  };
};

export default useSpecialties;
